var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconActiveSecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon - Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#E9F3FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-active 1",
    clipPath: "url(#clip0_1670_5633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 8C14.3696 8 8 14.3695 8 22C8 29.6304 14.3695 36 22 36C29.6304 36 36 29.6305 36 22C36 16.1859 32.2747 10.8495 26.8141 8.84988L26.1558 10.6478C30.8988 12.3846 34.0855 16.9467 34.0855 22C34.0855 28.6639 28.6639 34.0855 22 34.0855C15.3361 34.0855 9.91453 28.6639 9.91453 22C9.91453 15.3361 15.3361 9.91453 22 9.91453V8ZM23.6939 8.10155L23.4645 10.0023C23.9199 10.0572 24.3765 10.1391 24.8215 10.2455L25.2666 8.38328C24.7508 8.25997 24.2216 8.1652 23.6939 8.10155ZM22 12.7863C16.9196 12.7863 12.7863 16.9196 12.7863 22C12.7863 27.0804 16.9196 31.2137 22 31.2137C27.854 31.2137 32.3217 25.5629 30.9635 19.8634L29.1012 20.3073C30.1776 24.8243 26.6379 29.2991 22 29.2991C17.9752 29.2991 14.7009 26.0248 14.7009 22C14.7009 17.9752 17.9752 14.7009 22 14.7009C23.6817 14.7009 25.3243 15.2892 26.6251 16.3577L27.8402 14.8784C26.1979 13.5293 24.1238 12.7863 22 12.7863ZM29.7136 15.6914L21.8466 23.5584L18.8908 20.1863L17.4511 21.4482L21.0807 25.5892C21.5662 26.0235 22.1496 25.9637 22.4775 25.6351L31.0674 17.0452L29.7136 15.6914Z",
    fill: "#0095FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1670_5633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActiveSecondary);
export default __webpack_public_path__ + "static/media/IconActiveSecondary.db650f34b4108754150ce95b85ef15ce.svg";
export { ForwardRef as ReactComponent };